import React, { useState, useEffect, useRef, useCallback } from "react";
import "./Navbar.css"; 
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import "react-toastify/dist/ReactToastify.css";
import { Link } from "react-router-dom";
import { useNavigate, useLocation } from "react-router-dom";
import img from "./images/logo.png";
import { FaIdBadge, FaUser, FaBriefcase, FaBook, FaNewspaper,FaTag, FaShoppingCart, FaRegFolderOpen , FaEnvelope, FaMusic, FaSignOutAlt } from 'react-icons/fa';
import { FaXmark, FaShop, FaWpforms } from "react-icons/fa6";
import { MdMovie } from "react-icons/md";
import { GiHamburgerMenu } from "react-icons/gi";
import { setAccessToken, setRefreshToken } from "../../reducer/slices/authSlice";
import { createPortal } from "react-dom";
import Navbar from "react-bootstrap/Navbar";
import Logo from "../../FrontPage/Images/image.png";
import "../../ArtisitPages/Artist_navbar.css"

const AdminSidebar = () => {

     const [isOpen, setIsOpen] = useState(false);
  const { accessToken } = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // Logout function
  const handleLogout = () => {
  dispatch(setAccessToken(null));
  dispatch(setRefreshToken(null));
  localStorage.removeItem("accessToken");
  localStorage.removeItem("refreshToken");
  localStorage.removeItem("role");
  localStorage.removeItem("artId");
  toast.success("Successfully logged out", { position: "top-center" });
  navigate("/login");
  };


  const [accountPopupVisible, setAccountPopupVisible] = useState(false);
  const accountPopupRef = useRef(null);
  const accountBtnRef = useRef(null);
  // popup absolute position (computed)
  const [popupStyle, setPopupStyle] = useState({ top: 0, left: 0, width: 260 });
  
    const computePopupPosition = useCallback(() => {
      if (!accountBtnRef.current) return;
      const rect = accountBtnRef.current.getBoundingClientRect();
      const width = 260;
      const padding = 8;
      // default align right edge of popup to right edge of button
      let left = rect.right - width + window.scrollX;
      // clamp to viewport
      if (left < 8 + window.scrollX) left = rect.left + window.scrollX;
      if (left + width > window.innerWidth - 8 + window.scrollX)
        left = Math.max(8 + window.scrollX, window.innerWidth - width - 8 + window.scrollX);
      const top = rect.bottom + window.scrollY + padding;
      setPopupStyle({ top, left, width });
    }, []);
  
    const toggleAccountPopup = () => {
      const next = !accountPopupVisible;
      if (next) {
        computePopupPosition();
      }
      setAccountPopupVisible(next);
    };
  
    // close on clicks outside popup or button
    const handleClickOutside = useCallback(
      (event) => {
        const target = event.target;
        if (
          accountPopupRef.current &&
          !accountPopupRef.current.contains(target) &&
          accountBtnRef.current &&
          !accountBtnRef.current.contains(target)
        ) {
          setAccountPopupVisible(false);
        }
      },
      [accountPopupRef, accountBtnRef]
    );
  
    useEffect(() => {
      document.addEventListener("mousedown", handleClickOutside);
      // reposition on resize/scroll while visible
      const handleWindow = () => {
        if (accountPopupVisible) computePopupPosition();
      };
      window.addEventListener("resize", handleWindow);
      window.addEventListener("scroll", handleWindow, true);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
        window.removeEventListener("resize", handleWindow);
        window.removeEventListener("scroll", handleWindow, true);
      };
    }, [accountPopupVisible, handleClickOutside, computePopupPosition]);
  
    

  // Admin Sidebar menu items
  const menuItems = [
    { name: "Dashboard", icon: <FaIdBadge />, link: "/AdminDashboard" },
    { name: "Manage Users", icon: <FaUser />, link: "/users" },
    { name: "View Artists", icon: <FaRegFolderOpen />, link: "/ArtsistManagement" },
    { name: "Opportunities", icon: <FaBriefcase />, link: "/Opportunity" },
    { name: "Performances", icon: <MdMovie />, link: "/PerformanceEnquiries" }, 
    { name: "Application", icon: <FaWpforms />, link: "/OpportunityApplications" },
    // { name: "Skill Development", icon: <FaMusic />, link: "/CourseCategories" },
    {name: "Orders", icon: <FaShoppingCart />, link: "/view-orders"},
    {name: "MarketPlace", icon: <FaShop />, link: "/view-products"},
    { name: "Coupons", icon: <FaTag />, link: "/admin/coupons" },
    { name: "News", icon: <FaNewspaper />, link: "/admin/news" },
    // { name: "Contact Us", icon: <FaEnvelope />, link: "/contactUs" },
    { name: "Logout", icon: <FaSignOutAlt />, action: handleLogout },
  ];
  return (
    <aside className="sidebar" style={{width: isOpen ? "250px" : "80px", transition: "width 0.3s"}}>
        <h2 className="sidebar-title" style={{cursor: "pointer", color:"#fff", alignContent:"center"}}>{isOpen ? <p style={{display: "flex", alignItems:"center", justifyContent:"space-between", padding:"0px 10px 0px 20px"}}> Menu <span style={{fontWeight:"600", fontSize:"30px"}}> <FaXmark onClick={()=> setIsOpen(!isOpen)} style={{alignSelf:"end"}} /> </span> </p> : <p onClick={()=> setIsOpen(!isOpen)} style={{display:"flex", justifyContent:"center"}}> <GiHamburgerMenu /> </p>}</h2>
        <ul className="sidebar-menu">
          {menuItems.map((item, i) => (
            <li key={i}>
              {item.action ? (
                <button className="sidebar-link" style={{justifyContent: isOpen ? "flex-start" : "center", width:"100%"}} onClick={item.action}>
                  <span className="sidebar-icon">{item.icon}</span>
                  {
                      isOpen && (<span className="sidebar-text">{item.name}</span>)
                  }
                </button>
              ) : (
                <Link
                  to={item.link}
                  className={`sidebar-link ${
                    location.pathname === item.link ? "active" : ""
                  }`} style={{justifyContent: isOpen ? "flex-start" : "center"}}
                >
                  <span className="sidebar-icon">{item.icon}</span>
                  {!isOpen && <span className="tooltip">{item.name}</span>}
                  {
                      isOpen && (<span className="sidebar-text">{item.name}</span>)
                  }
                </Link>
              )}
            </li>
          ))}
        </ul>
      </aside>
  )
}

export default AdminSidebar